module.exports = __webpack_public_path__ + "static/media/reverse_direction.328817c5.svg";